import React, {  useEffect, useState,useContext  } from "react";
import Lang from '../lang/translations';
import {  Link  } from "react-router-dom";
import helpersFunction from "../_helpers/helpersFunction";
import Context from '../context/context';
import '../../components_css/chat_menu.css';




export default function Chat_desktop_list() {

	const country = helpersFunction.getCountry()
	const context = useContext(Context)
	const folder = helpersFunction.getCDNfolder()
	const [conversazioni, setConversazioni] = useState();
	const {collection_folder, default_folder} = helpersFunction.getCDNfolder();
	const [menuAperto, setMenuAperto] = useState(null);
	const [confermaElimina, setConfermaElimina] = useState(null);

	useEffect(() => {
		if (!menuAperto) return;
		const chiudi = () => { setMenuAperto(null); setConfermaElimina(null); };
		document.addEventListener('click', chiudi);
		return () => document.removeEventListener('click', chiudi);
	}, [menuAperto]);
	
	useEffect(() => {
		
		if(conversazioni){
			getMessages()
			
		}
	},[context.nuovoMessaggio]);


	useEffect(() => {  
		getMessages();
	},[]);



	function getMessages(){
		const trackerId = localStorage.getItem('trackerId');
		const token = localStorage.getItem('token');
		
		fetch(process.env.REACT_APP_APIADDRESS+"/get/messages/"+trackerId,{ 
			method: 'get', 
			headers: {
				'Authorization': 'Bearer '+ token
			}
		})
			.then(response => response.json())
			.then(data => {
				if(Object.keys(data).length !== 0){
					setConversazioni(data.messages)
					context.SetMessaggiNonLetti(data.totalUnreadMessages)
				}
				
			}).catch(err => {
				console.log(err)
			})
  	}



	function OrdinaPerOra(array){
		array.sort(function(a,b){
			return new Date(b.time) - new Date(a.time);
		  });
	}
		

	function DisplayConversazioniPrecedenti(){
		let tempConversazioni = [];
		if(conversazioni){

			//OrdinaPerOra(conversazioni);

			for(let i=0;i<conversazioni.length;i++){
				tempConversazioni.push(CreaElemento(conversazioni[i],i))
			}

			
		
			return (<div>{tempConversazioni}</div>)
		}else{
			return (<div className="notification_content no_content" id="chatHeight">
                <div className="text-center absolute_icebreaker">
                    
                    <p><Lang w={"nessun_messaggio"} page={"create_list"}/></p>
                   
                </div>
            </div>)
		}
	}




	function CreaElemento(messaggio,index){
		var time = new Date(messaggio.time);
		var time = time.getHours() + ":" + (time.getMinutes()<10?'0':'') + time.getMinutes();
		var url = "";

		var tmp_time = new Date(messaggio.time)
		if(!helpersFunction.isToday(tmp_time)){
			var giorno = tmp_time.getDate().toString().padStart(2, "0"); // Giorno con 2 cifre
			var month = (tmp_time.getMonth() + 1).toString().padStart(2, "0"); // Mese con 2 cifre
			var year = tmp_time.getFullYear(); // Anno
			var day = `${giorno}/${month}/${year}`; // Data formattata
	
		}

		var messaggioDaVisualizzare = "";
		
		if (messaggio.type === "photo") {
			messaggioDaVisualizzare = "📷 Foto";
		} else {
			if(context.premiumLevel == 0){
				messaggioDaVisualizzare = messaggio.blurredMessage ? messaggio.blurredMessage : messaggio.msg
			}else{
				messaggioDaVisualizzare = messaggio.msg;
			}
		}
		
		if(messaggioDaVisualizzare.length > 25){
			messaggioDaVisualizzare = messaggioDaVisualizzare.substring(0, 25) + "\u2026"
		}else{
			messaggioDaVisualizzare = messaggioDaVisualizzare.substring(0, 25) 
		}
		

		if(messaggio.type == "like"){
			url = "/user/"+messaggio.angelId;
		}else{
			url= "/chats/"+messaggio.angelId;
		}

		return (
			<div key={index} style={{ position: 'relative'}}>
				<Link to={url}>
					<li id="single_chat">
						{(!messaggio.letto) && (messaggio.type !== "like") && (<span className="badge badge-danger nuovo_messaggio"><Lang w={"non_letto"} page={"create_list"}/></span>)}
						<div className="a clearfix">
							<div>
								<img src={process.env.REACT_APP_CDN+"/"+default_folder+"/"+messaggio.angelId+".jpg"} alt="" width={170} height={110} />
							</div>
							<div className="a_name">
								{messaggio.screenName}
							</div>
							<div className="last-message text-muted">
								{stampaMessaggio(messaggio,messaggioDaVisualizzare)}
								{messaggio.type == "like" && (<><i className="far fa-eye red"></i> <span className="listaMessaggi"><Lang w={"hai_ricevuto"} page={"create_list"}/></span></>)}
								<div className="time">
									<p>
										<small>{day && (day + "-") }</small>
										<small>{time}</small>
									</p>
								</div>
							</div>
						</div>
					</li>
				</Link>
				<div className="chat-menu-wrapper">
					<button className="chat-menu-btn" onClick={(e) => { e.stopPropagation(); setMenuAperto(menuAperto === messaggio.angelId ? null : messaggio.angelId); setConfermaElimina(null); }}>⋮</button>
					{menuAperto === messaggio.angelId && (
						<div className="chat-dropdown" onClick={(e) => e.stopPropagation()}>
							{confermaElimina === messaggio.angelId ? (
								<div className="chat-dropdown-confirm">
									<span><Lang w={"sei_sicuro"} page={"create_list"}/></span>
									<button onClick={() => eseguiElimina(messaggio.angelId)}><Lang w={"si"} page={"create_list"}/></button>
									<button onClick={() => { setMenuAperto(null); setConfermaElimina(null); }}><Lang w={"no"} page={"create_list"}/></button>
								</div>
							) : (
								<button onClick={() => setConfermaElimina(messaggio.angelId)}><Lang w={"elimina_chat"} page={"create_list"}/></button>
							)}
						</div>
					)}
				</div>
			</div>
		)
	}


	function set_img_url(el) {
		if (context.user_info.cerco === "uomo") {
			return "https://yp.cloudfileimages.com/uploads/photo/" + el.default_photo
		} else {
			return process.env.REACT_APP_CDN + "/" + default_folder + "/" + el.id + ".jpg"
		}
	}
	
	
	function stampaMessaggio(messaggio,messaggioDaVisualizzare){
		var renderMessaggio = ""
		if(!messaggio.letto){
			renderMessaggio = messaggio.idNotifica == "benvenuto" ? (<p className="nonLetto listaMessaggi" dangerouslySetInnerHTML={{__html: messaggioDaVisualizzare}}></p>) : (<p className="nonLetto listaMessaggi">{messaggioDaVisualizzare}</p>)
		}
		if(messaggio.letto){
			renderMessaggio = messaggio.idNotifica == "benvenuto" ? (<p className="listaMessaggi" dangerouslySetInnerHTML={{__html: messaggioDaVisualizzare}}></p>) : (<p className="listaMessaggi">{messaggioDaVisualizzare}</p>)
		}
		if(messaggio.type == "like"){

		}
		return renderMessaggio
	}
	
	async function eseguiElimina(angelId) {
		setMenuAperto(null);
		setConfermaElimina(null);
		setConversazioni(prev => prev.filter(c => c.angelId !== angelId));

		const trackerId = localStorage.getItem('trackerId');
		const token = localStorage.getItem('token');

		try {
			await fetch(process.env.REACT_APP_APIADDRESS + '/chat/hide', {
				method: 'POST',
				headers: {
					'Authorization': 'Bearer ' + token,
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ clickid: trackerId, angelId })
			});
		} catch (err) {
			console.log('Errore eseguiElimina', err);
			getMessages();
		}
	}
	
	
	return DisplayConversazioniPrecedenti();
	
	
}